import styled from "styled-components";

import { HttpLayout } from "src/organization/pages/project/environment/metrics/http/components";

export const TimelineHeight = 240;

export const Container = styled.div`
  height: ${TimelineHeight}px;
  overflow: hidden;

  .skeleton {
    height: ${TimelineHeight}px;
  }
`;

export const Layout = styled(HttpLayout)``;
